import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class TimeOffEntry extends BaseBus
{
    constructor(busObj: TimeOffEntry = null) {
        super(busObj);
        this.date = DateFunctions.getDate(this.date);
    }
    date: Date;
    hours: number;
}
